import type { propsIconsNames } from '~/atomic/atoms/Icon/interfaces';

export type ModalStatusType = 'icon' | 'success' | 'error' | 'alert';

export interface PropsModalStatus {
  type?: ModalStatusType;
  icon?: propsIconsNames;
  iconColor?: string;
  iconBgColor?: string;
  iconBorderColor?: string;
  hasStrokeIcon?: boolean;
  title: string;
  description?: string;
  textFirstButton?: string;
  textSecondButton?: string;
  showFirstButton?: boolean;
  showSecondButton?: boolean;
  onClickFirstButton?: () => void;
  onClickSecondButton?: () => void;
  handleCloseModal?: () => void;
}

type State = (PropsModalStatus & { visible: true }) | { visible: false };

type Listener = (state: State) => void;

let state: State = { visible: false };
const listeners = new Set<Listener>();

const notify = () => {
  listeners.forEach((l) => l(state));
};

const modalStatusService = {
  show(payload: PropsModalStatus) {
    state = { ...payload, visible: true };
    notify();
  },
  hide() {
    state = { visible: false };
    notify();
  },
  subscribe(listener: Listener) {
    listeners.add(listener);
    listener(state);
    return () => listeners.delete(listener);
  },
};

export default modalStatusService;
